import React, { Component } from 'react';
import Radium from 'radium';

import TaskCircle from "./TaskCircle";

import TextareaAutosize from 'react-autosize-textarea';

const CHANGE_WAIT = 500;

class Task extends Component {

	constructor(props) {
		super(props);
		this.state = {
			editedTitle: ""
		};

		this.contentEditable = React.createRef();
	}
	
	componentDidMount() {
		//this.refs.task.innerText = this.state.editedTitle;
	}

	componentWillUnmount() {
		if (this._changeTimer) {
			clearTimeout(this._changeTimer);
			
			// Pass through the update (this is a change to how it was handled before!)
			this.props.onChange(this.state.newValue);
		}
	}

	onTick(evt) {
		if (this.props.task.task && this.props.task.task.id) {
			this.props.onTick(evt);
		}
	}

	getTitle() {
		if (!this.props.task) {
			return this.state.editedTitle;
		}

		return this.props.task.title;
	}

	async onSave(newValue) {
		if (this._changeTimer) {
			clearTimeout(this._changeTimer);
			await this.setState({
				newValue: null
			});
		}

		if (newValue.trim().length === 0) {
			// Change straightaway
			this.props.onChange(this.state.newValue);
		} else {
			await this.setState({
				newValue: newValue
			});

			this._changeTimer = setTimeout(() => {
				this.props.onChange(this.state.newValue);	
			}, CHANGE_WAIT);
		}
	}

	async onChangeTitle() {
		const newValue = this.contentEditable.current.elem.innerText;
		
		await this.setState({
			editedTitle: newValue
		});

		this.onSave(newValue);
	}

	isCompleted() {
		if (this.props.task && this.props.task.task && this.props.task.task.completed) {
			return true;
		}

		return false;
	}

	clear() {
		this.contentEditable.current.elem.innerText = "";
	}

	getValue() {
		return this.contentEditable.current.elem.innerText;
	}

	setValue(value) {
		this.contentEditable.current.elem.innerText = value;
	}

	moveCursorToEnd(el) {
		var range = document.createRange();
		var sel = window.getSelection();
		range.setStart(el.childNodes[0], el.innerText.length);
		range.collapse(true);
		sel.removeAllRanges();
		sel.addRange(range);
		el.focus();
	}

	onOuterContainerClick() {
		if (this.contentEditable.current.elem !== document.activeElement) {
			this.contentEditable.current.elem.focus();
			this.moveCursorToEnd(this.contentEditable.current.elem);
		}
	}

	onContextMenu(evt) {
		evt.stopPropagation();
		evt.preventDefault();
		evt.target.blur();
		window.getSelection().removeAllRanges();

		this.props.onShowTaskMenu(this.props.task.task, evt);

		return false;
	}

	renderOverlay() {
		if (!this.props.selectedTaskMenu) {
			return null;
		}

		if (this.props.selectedTaskMenu.task.id !== this.props.task.task.id) {
			return (
				<div style={this.localStyles().overlay}>

				</div>
			)
		}

		return null;
	}

	onChangeTextArea(evt) {
		var task = this.props.task;
		task.task.title = evt.target.value;

		this.props.onEditorStateChange(task)
	}

	getTitleStyles() {
		var titleStyles = this.localStyles().title;

		if (this.isCompleted()) {
			Object.keys(this.localStyles().titleCompleted).forEach((key) => {
				titleStyles[key] = this.localStyles().titleCompleted[key];
			});
		}

		return titleStyles;
	}

	render() {
		var titleStyles = this.getTitleStyles();

		return (
			<div style={this.localStyles().container}>
				<div style={this.localStyles().taskHolder}>
					<TaskCircle 
						style={this.props.style}
						placeholder={this.getTitle() === ""}
						completed={this.isCompleted()} 
						selectedBubble={this.props.selectedBubble}
						onTick={(evt) => this.onTick(evt)}/>
				</div>
				
				
				<div style={titleStyles} onContextMenu={(evt) => this.onContextMenu(evt)}>
					<TextareaAutosize
						style={titleStyles}
						value={this.props.task.task.title}
						placeholder="Add task"
						onChange={(evt) => this.onChangeTextArea(evt)}
					/>
				</div>		
				{this.renderOverlay()}		
			</div>
		);
	}

	localStyles () {
		return {
			title: {
				fontSize: 24,
				fontWeight: "700",
				color: this.props.style.colors.black,
				//transition: "all 0.1s ease-in-out",
				outline: "none",
				border: "none",
				width: "100%"
			},
			titleCompleted: {
				color: this.props.style.colors.lightText,
				textDecoration: "line-through"
			},
			overlay: {
				position: "absolute",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: this.props.style.colors.transparentOverlay,
				animation: 'opacity 0.2s ease-in-out 0s',
				animationName: fadeInKeyframes
			},
			container: {
				position: "relative",
				display: "flex",
				flexDirection: "row",
				alignItems: "flex-start",
				marginTop: 10,
				minWidth: 280,
				cursor: "pointer"
			},
			taskHolder: {
				paddingTop: 3
			}
		}
	};
}

const fadeInKeyframes = Radium.keyframes({
	"0%": {opacity: 0},
	"100%": {opacity: 1}
}, 'fadeIn');

export default Radium(Task);


// WEBPACK FOOTER //
// ./src/components/Task.js